import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { setSettingForApp } from 'entities/user/module/app-settings'

import PromoImage from 'shared/images/umrah-main.webp'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const UmrahPromoKey = 'umrah_promo'

interface UmrahPromoProps {
  onClose: () => void
}

export const UmrahPromo = ({ onClose }: UmrahPromoProps) => {
  const { t } = useTranslation()

  const handleApply = () => {
    void setSettingForApp({ key: UmrahPromoKey, value: 'seen' })
    onClose()
  }

  return (
    <div className={clsx('safe-area-top-padding', s.container)}>
      <div className={s.info}>
        <p className={clsx('extra-bold-24', s.title)}>
          {t('umrah_block.for_family')}
        </p>
        <p className={clsx('medium-14', s.subtitle)}>
          {t('umrah_block.certificate_text')}
        </p>

        <span className={clsx('medium-12', s.tag)}>
          {t('umrah_block.gift_text')}
        </span>
      </div>

      <Button
        onClick={handleApply}
        className={s.button}
      >
        {t('umrah_block.start_journey')}
      </Button>

      <div className={s.image}>
        <ImageLazy
          src={PromoImage}
          alt={'promo image'}
        />
      </div>
    </div>
  )
}
